export class ProfileUserModel {
  profileUserId: number = 0;
  code: number = 0;
  name: string = '';
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}